// extracted by mini-css-extract-plugin
export default {"counter":"counter_counter__Wafa7","default":"counter_default__P6bB3","small":"counter_small__foBzw","counter__num":"counter_counter__num__IM-KL"};